import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { Redux } from 'src/store'
import { GygSectionsType } from '@/src/types/apps/gygSections'

type GygSectionsTimeSlotsTypeStateType = {
  sections: GygSectionsType[]
  sectionsTree?: GygSectionsType[]
  mainSectionsWithOrder: Record<string, number>
  getSectionPending: boolean
  getSection: GygSectionsType | null
  pending: boolean
  updateSectionPending: boolean
  errors: any // todo
}

interface GetSectionsListResponse {
  data: GygSectionsType[]
}
interface GetSectionListResponse {
  data: GygSectionsType
}
interface GetMainSectionsWithOrderResponse {
  data: Record<string, number>
}

const initialState: GygSectionsTimeSlotsTypeStateType = {
  sections: [],
  sectionsTree: [],
  mainSectionsWithOrder: {},
  getSection: null,
  errors: {},
  pending: false,
  getSectionPending: false,
  updateSectionPending: false
}

export const getSectionsLists = createAsyncThunk<GetSectionsListResponse, void, Redux>(
  'gygSectionsList/getSections',
  async (_, { extra }) => {
    const response = await extra.httpClient(`sections`)

    return response.data
  }
)

export const getSectionsList = createAsyncThunk<GetSectionListResponse, string, Redux>(
  'gygSectionsList/getSection',
  async (id: string, { extra }) => {
    const response = await extra.httpClient(`sections/${id}`)

    return response.data
  }
)

export const getSectionsTree = createAsyncThunk<any, void, Redux>(
  'gygSectionsList/getSectionsTree',
  async (_, { extra }) => {
    const response = await extra.httpClient(`sections/tree`)

    return response.data
  }
)

export const getMainCateringSectionsWithOrder = createAsyncThunk<GetMainSectionsWithOrderResponse, string, Redux>(
  'gygSectionsList/getMainCateringSectionsWithOrder',
  async (type: string, { extra }) => {
    const response = await extra.httpClient(`sections/allMainSectionsWithOrder?type=${type}&isCommonSection=0`)

    return response.data
  }
)

export const gygSectionList = createSlice({
  name: 'gygSectionsList',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder

      // All Stores Sections
      .addCase(getSectionsLists.fulfilled, (state, action) => {
        state.sections = action.payload.data
        state.pending = false
      })
      .addCase(getSectionsLists.pending, state => {
        state.pending = true
      })
      .addCase(getSectionsLists.rejected, state => {
        state.pending = false
      })

      // All sections with tree view
      .addCase(getSectionsTree.fulfilled, (state, action) => {
        state.sectionsTree = action.payload.data
        state.pending = false
      })
      .addCase(getSectionsTree.pending, state => {
        state.pending = true
      })
      .addCase(getSectionsTree.rejected, state => {
        state.pending = false
      })

      // Single Store Sections
      .addCase(getSectionsList.fulfilled, (state, action) => {
        state.getSection = action.payload.data
        state.getSectionPending = false
      })
      .addCase(getSectionsList.pending, state => {
        state.getSectionPending = true
      })
      .addCase(getSectionsList.rejected, state => {
        state.getSectionPending = false
      })

      // All Main Sections With Order
      .addCase(getMainCateringSectionsWithOrder.fulfilled, (state, action) => {
        state.mainSectionsWithOrder = action.payload.data
        state.pending = false
      })
      .addCase(getMainCateringSectionsWithOrder.pending, state => {
        state.pending = true
      })
      .addCase(getMainCateringSectionsWithOrder.rejected, state => {
        state.pending = false
      })
  }
})

export default gygSectionList.reducer
